import { SocItem } from "../../../domain/SocItem";
import { Grid, Typography } from "@material-ui/core";
import { SectionProps } from "../SectionProps";
import { Controller } from "react-hook-form";
import { Error } from "../../common/Error";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { fieldLabels } from "../fieldLabels";

export const QuestionFiveSection: React.FC<SectionProps<SocItem>> = (
  sectionProps
) => {
  const { control, disabled, errors } = sectionProps;

  return (
    <Grid item xs={12} sm={12}>
      <Typography variant="body1">
        Aside from inflation, what are the main financial risks and
        opportunities facing your organisation over the next 12 months? For each
        risk highlighted, please explain mitigation plans. You may wish to
        include details of risks that have arisen from the impact of COVID-19 or
        the government’s review of qualifications. These risks could be
        short-term, or long-term.
      </Typography>
      <Controller
        control={control}
        rules={{ maxLength: 5000, required: true }}
        name="financialRisk"
        as={
          <TextField
            label={fieldLabels.financialRisk}
            readOnly={disabled}
            data-test="financialRisk-field"
            rows={8}
            multiline
            required
          />
        }
      />
      {errors.financialRisk?.type === "maxLength" && (
        <Error data-test="financialRisk-validation">
          Must be no more than 5,000 characters
        </Error>
      )}
      {errors.financialRisk?.type === "required" && (
        <Error data-test="financialRisk-validation">
          This field is required
        </Error>
      )}
    </Grid>
  );
};
